import { createFileRoute } from '@tanstack/react-router';
import { warmBackground } from '@/api/loaders';
import { oauthConsent } from '@/api/resources';
import { parseConnectSearch } from '@/lib/oauth-consent';
import { requireConsentSession } from '@/lib/route-guards';
import { ConnectScreen } from '@/screens/connect';

// The consent page an app (Claude) sends a person to from `/oauth/authorize`
// (docs/plans/claude-connector.md §3). On a public path (lib/public-paths.ts): no app chrome, a
// screen about one decision. It still needs a session; without one the guard sends the person
// to `/login?next=connect&request=<id>`, and a sign-in returns them here.
export const Route = createFileRoute('/connect')({
  validateSearch: parseConnectSearch,
  beforeLoad: requireConsentSession,
  loaderDeps: ({ search }) => ({ request: search.request }),
  // Search-driven route: no skeleton for an in-screen navigation (router.ts).
  pendingMs: Infinity,
  // In the background, not blocking: a request already answered or lapsed answers 404, and that
  // is the screen's own state ("start again from Claude"), never the router's error page.
  loader: ({ context, deps }) => {
    if (deps.request) warmBackground(context.queryClient, oauthConsent(deps.request));
  },
  component: Page,
});

function Page() {
  const { request } = Route.useSearch();
  return <ConnectScreen requestId={request} />;
}
